import { FC, useEffect } from 'react';
import { Button, message, Upload } from 'antd';
import { observer } from 'mobx-react';
import { DeleteOutlined } from '@ant-design/icons';
import { useLocalImg } from '@/store';
import { $fm, $t } from '@/Intl';
import './LocalImgUpload.less';

// 上传本地图片
const LocalImgUpload: FC<CustomFieldsProps> = (props) => {
  const [localImg, setLocalImg] = useLocalImg();
  const { value, onChange } = props;

  useEffect(() => {
    if (localImg) {
      onChange && onChange(localImg.name, localImg);
    } else {
      onChange && onChange('', null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localImg]);

  const beforeUpload = (file: File) => {
    if (!/\.(jpg|svg|png|jpeg|bmp)$/.test(file.name)) {
      message.error($t('IMG_ERROR'));
      return false;
    }
    setLocalImg(file);

    return false;
  };

  const handleDelete = () => {
    setLocalImg(null);
  };

  return (
    <div className='localimg-upload'>
      <Upload
        className='localimg-upload-btn'
        beforeUpload={beforeUpload}
        showUploadList={false}
        accept='.png,.svg,.jpg,.jpeg,.bmp'
      >
        <Button type='primary'>{$fm('UPLOAD')}</Button>
      </Upload>
      {value ? (
        <>
          <span className='localimg-name'>{value}</span>
          <DeleteOutlined className='delete-localimg' onClick={handleDelete} />
        </>
      ) : null}
    </div>
  );
};

export default observer(LocalImgUpload);
